var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-page"},[_c('el-container',[_c('el-header',{attrs:{"height":"8rem"}},[_c('bear-header',{on:{"change":_vm.changePush}})],1),_c('el-main',[_c('bear_content',{ref:"contBox"},[_c('router-view',{attrs:{"bear-ref":_vm.$refs.contBox}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }